import React, { useEffect, useState } from 'react';
import azim from '../files/azim-width.png';
// import pdf from '../files/faijul-azim-resume-web-developer.pdf'
// import download from '../files/download.png';
import open from '../files/open.png';
import { motion } from "framer-motion"


function Banner() {

    const TextVariants = {
        offscreen: {
            width: 0,
            opacity: 0
        },
        onscreen: {
            width: "auto",
            opacity: 1
        },
        exit: {
            width: 0,
            opacity: 0
        }
    };

    const Name = ["Faijul Azim"];
    const details = ["Full stack Developer", 'MERN stack Developer', 'Web Developer'];
    const [currentName, setCurrentName] = useState(-1);
    const [currentDetails, setCurrentDetails] = useState(-1);

    useEffect(() => {
        let i = 0;
        const interval = setInterval(() => {
            if (i === Name.length) {
                setCurrentName(0);
                i = 0;
            } else setCurrentName(i);
            i++;
        }, 1000 + Name[i].length * 0.25);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        let i = 0;
        const detailsInterval = setInterval(() => {
            if (i === details.length) {
                setCurrentDetails(0);
                i = 0;
            } else setCurrentDetails(i);
            i++;
        }, 3000 + details[i].length * 0.25);

        return () => clearInterval(detailsInterval);
    }, []);



    return (
        <div id='home' className='bg-[#18191A] sm:h-[220px] px-4 py-10 lg:px-0 lg:py-0 lg:h-[570px] md:h-[370px] flex '>

            <div className='lg:w-6/12 w-100 mx-auto  grid content-center lg:ml-36 '>

                {/* <h1 className='lg:text-7xl text-3xl font-bold  text-white pb-2 lg:pb-5'>Faijul Azim</h1> */}
                <motion.h1
                    className="lg:text-7xl md:text-5xl text-4xl font-bold text-[#17A875] pb-2 lg:pb-5 lg:text-left md:text-left  text-center"
                    transition={{ staggerChildren: 0.2, duration: 0.1 }}
                >
                    {Name.map((word, index) =>
                        index === currentName ? (
                            <motion.span key={index}>
                                {word.split("").map((r, id) => (
                                    <motion.span
                                        initial="offscreen"
                                        animate="onscreen"
                                        exit="exit"
                                        variants={TextVariants}
                                        transition={{
                                            duration: 0.1,
                                            delay: id * 0.1
                                        }}
                                        key={id}
                                    >
                                        {r}
                                    </motion.span>
                                ))}
                            </motion.span>
                        ) : null
                    )}
                </motion.h1>

                {/* <h3 className='lg:text-4xl  font-thin tracking-wider text-white pb-2 lg:pb-5'>Web Developer (MERN)</h3> */}
                <motion.h3
                    className="lg:text-4xl md:text-2xl text-xl  tracking-wider lg:text-left md:text-left text-center text-white pb-2 lg:pb-5"
                    transition={{ staggerChildren: 0.2, duration: 0.1 }}
                >
                    {details.map((word, index) =>
                        index === currentDetails ? (
                            <motion.span key={index}>
                                {word.split("").map((r, id) => (
                                    <motion.span
                                        initial="offscreen"
                                        animate="onscreen"
                                        exit="exit"
                                        variants={TextVariants}
                                        transition={{
                                            duration: 0.1,
                                            delay: id * 0.1
                                        }}
                                        key={id}
                                    >
                                        {r}
                                    </motion.span>
                                ))}
                            </motion.span>
                        ) : null
                    )}
                </motion.h3>


                <div className='flex  mt-3'>
                    <a className='mr-3 ' data-aos="flip-up" data-aos-delay="600" data-aos-duration="1000"
                        href='https://drive.google.com/file/d/1AaSLGoHACuUm6eIXkAAOy9Ohg79ZzUbb/view' target='_bla
                    '
                    ><button className='btn bg-[#17A875] hover:border-[#17A875] text-xs rounded-sm lg:w-36 w-28 btn-sm lg:h-10 h-6  text-white font-light lg:text-lg'>CV <img className='lg:w-5 w-4 ml-4' src={open} alt='' /></button></a>

                    <a data-aos="flip-up" data-aos-delay="600" data-aos-duration="1000"
                        href='https://drive.google.com/file/d/1uDz6H844Ym67910rWk1hQYkz6iFFFVx0/view?usp=sharing' target='_bla
                    '
                    ><button className=' lg:mt-0 btn bg-[#17A875] hover:border-[#17A875] text-xs rounded-sm lg:w-36 w-28 btn-sm lg:h-10 h-6 text-white font-light lg:text-lg'>Resume <img className='lg:w-5 w-3  ml-4' src={open} alt='' /></button></a>
                </div>
            </div>

            <div data-aos="fade-left" data-aos-duration="1000" data-aos-offset="300" data-aos-easing="ease-in-sine" className='lg:w-6/12 w-5/12 lg:block md:block hidden'>
                <img className='bannerImg  rounded-full lg:w-96 w-48  mt-12 lg:mt-24 shadow-md shadow-[#17A875]' src={azim} alt='' />
            </div>

        </div>
    )
}

export default Banner;
